// source: itrdrmsgs.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var session_pb = require('./session_pb.js');
goog.object.extend(proto, session_pb);
var singlegeneralorderhandling_pb = require('./singlegeneralorderhandling_pb.js');
goog.object.extend(proto, singlegeneralorderhandling_pb);
var itrdrmsgs_common_pb = require('./itrdrmsgs_common_pb.js');
goog.object.extend(proto, itrdrmsgs_common_pb);
var itrdrorder_pb = require('./itrdrorder_pb.js');
goog.object.extend(proto, itrdrorder_pb);
var itrdrinstrumentstatus_pb = require('./itrdrinstrumentstatus_pb.js');
goog.object.extend(proto, itrdrinstrumentstatus_pb);
var itrdrinstrument_pb = require('./itrdrinstrument_pb.js');
goog.object.extend(proto, itrdrinstrument_pb);
goog.exportSymbol('proto.it_grpc.AllocationProfile', null, global);
goog.exportSymbol('proto.it_grpc.AllocationProfile.SplitDefaults', null, global);
goog.exportSymbol('proto.it_grpc.AllocationProfile.report_typ_enum', null, global);
goog.exportSymbol('proto.it_grpc.HolidayCalendar', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrAllocationProfile', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrAllocationProfileMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrExchange', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrExecutionReport', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrExecutionReportAck', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrExecutionReportAckMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrExecutionReportMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrHolidayCalendar', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrHolidayCalendarMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentDefinitionMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentDefinitions', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentSaveRequest', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentTemplate', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentTemplateMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrInstruments', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrOrderIDs', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrOrderMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrOrderOwnershipTransferMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrOrders', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrOvernightOrderMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrOvernightOrders', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrSalesTicket', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrSalesTicketMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrSettlementDates', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrUserAuthentication', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrUserAuthentication.LogonResponseCase', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrUserConfiguration', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrUserConfigurationMsg', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrUserCredentials', null, global);
goog.exportSymbol('proto.it_grpc.InstrumentTemplate', null, global);
goog.exportSymbol('proto.it_grpc.NVPair', null, global);
goog.exportSymbol('proto.it_grpc.SalesTicket', null, global);
goog.exportSymbol('proto.it_grpc.UserConfiguration', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrSettlementDates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrSettlementDates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrSettlementDates.displayName = 'proto.it_grpc.ITrdrSettlementDates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentDefinitions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrInstrumentDefinitions.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentDefinitions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentDefinitions.displayName = 'proto.it_grpc.ITrdrInstrumentDefinitions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentDefinitionMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentDefinitionMsg.displayName = 'proto.it_grpc.ITrdrInstrumentDefinitionMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstruments = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrInstruments.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrInstruments, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstruments.displayName = 'proto.it_grpc.ITrdrInstruments';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentSaveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentSaveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentSaveRequest.displayName = 'proto.it_grpc.ITrdrInstrumentSaveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentMsg.displayName = 'proto.it_grpc.ITrdrInstrumentMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrOrderOwnershipTransferMsg.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrOrderOwnershipTransferMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrOrderOwnershipTransferMsg.displayName = 'proto.it_grpc.ITrdrOrderOwnershipTransferMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrOrderIDs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrOrderIDs.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrOrderIDs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrOrderIDs.displayName = 'proto.it_grpc.ITrdrOrderIDs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrOrderMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrOrderMsg.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrOrderMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrOrderMsg.displayName = 'proto.it_grpc.ITrdrOrderMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrOvernightOrders = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrOvernightOrders.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrOvernightOrders, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrOvernightOrders.displayName = 'proto.it_grpc.ITrdrOvernightOrders';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrOvernightOrderMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrOvernightOrderMsg.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrOvernightOrderMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrOvernightOrderMsg.displayName = 'proto.it_grpc.ITrdrOvernightOrderMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrOrders = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrOrders.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrOrders, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrOrders.displayName = 'proto.it_grpc.ITrdrOrders';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrExecutionReportMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrExecutionReportMsg.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrExecutionReportMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrExecutionReportMsg.displayName = 'proto.it_grpc.ITrdrExecutionReportMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrExecutionReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrExecutionReport.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrExecutionReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrExecutionReport.displayName = 'proto.it_grpc.ITrdrExecutionReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrExecutionReportAckMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrExecutionReportAckMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrExecutionReportAckMsg.displayName = 'proto.it_grpc.ITrdrExecutionReportAckMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrExecutionReportAck = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrExecutionReportAck.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrExecutionReportAck, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrExecutionReportAck.displayName = 'proto.it_grpc.ITrdrExecutionReportAck';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrUserAuthentication = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.it_grpc.ITrdrUserAuthentication.oneofGroups_);
};
goog.inherits(proto.it_grpc.ITrdrUserAuthentication, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrUserAuthentication.displayName = 'proto.it_grpc.ITrdrUserAuthentication';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrUserCredentials = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrUserCredentials, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrUserCredentials.displayName = 'proto.it_grpc.ITrdrUserCredentials';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrAllocationProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrAllocationProfile.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrAllocationProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrAllocationProfile.displayName = 'proto.it_grpc.ITrdrAllocationProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrAllocationProfileMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrAllocationProfileMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrAllocationProfileMsg.displayName = 'proto.it_grpc.ITrdrAllocationProfileMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrExchange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrExchange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrExchange.displayName = 'proto.it_grpc.ITrdrExchange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.NVPair = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.NVPair, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.NVPair.displayName = 'proto.it_grpc.NVPair';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.AllocationProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.AllocationProfile.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.AllocationProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.AllocationProfile.displayName = 'proto.it_grpc.AllocationProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.AllocationProfile.SplitDefaults = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.AllocationProfile.SplitDefaults.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.AllocationProfile.SplitDefaults, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.AllocationProfile.SplitDefaults.displayName = 'proto.it_grpc.AllocationProfile.SplitDefaults';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrSalesTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrSalesTicket.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrSalesTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrSalesTicket.displayName = 'proto.it_grpc.ITrdrSalesTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrSalesTicketMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrSalesTicketMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrSalesTicketMsg.displayName = 'proto.it_grpc.ITrdrSalesTicketMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.SalesTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.SalesTicket.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.SalesTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.SalesTicket.displayName = 'proto.it_grpc.SalesTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentTemplate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrInstrumentTemplate.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentTemplate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentTemplate.displayName = 'proto.it_grpc.ITrdrInstrumentTemplate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentTemplateMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentTemplateMsg.displayName = 'proto.it_grpc.ITrdrInstrumentTemplateMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.InstrumentTemplate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.InstrumentTemplate.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.InstrumentTemplate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.InstrumentTemplate.displayName = 'proto.it_grpc.InstrumentTemplate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrHolidayCalendar = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrHolidayCalendar.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrHolidayCalendar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrHolidayCalendar.displayName = 'proto.it_grpc.ITrdrHolidayCalendar';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrHolidayCalendarMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrHolidayCalendarMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrHolidayCalendarMsg.displayName = 'proto.it_grpc.ITrdrHolidayCalendarMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.HolidayCalendar = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.HolidayCalendar.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.HolidayCalendar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.HolidayCalendar.displayName = 'proto.it_grpc.HolidayCalendar';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrUserConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrUserConfiguration.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrUserConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrUserConfiguration.displayName = 'proto.it_grpc.ITrdrUserConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrUserConfigurationMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrUserConfigurationMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrUserConfigurationMsg.displayName = 'proto.it_grpc.ITrdrUserConfigurationMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.UserConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.UserConfiguration.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.UserConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.UserConfiguration.displayName = 'proto.it_grpc.UserConfiguration';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrSettlementDates.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrSettlementDates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrSettlementDates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrSettlementDates.toObject = function(includeInstance, msg) {
  var f, obj = {
    cashSettlementDate: jspb.Message.getFieldWithDefault(msg, 1, 0),
    futuresSettlementDate: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrSettlementDates}
 */
proto.it_grpc.ITrdrSettlementDates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrSettlementDates;
  return proto.it_grpc.ITrdrSettlementDates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrSettlementDates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrSettlementDates}
 */
proto.it_grpc.ITrdrSettlementDates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCashSettlementDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFuturesSettlementDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrSettlementDates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrSettlementDates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrSettlementDates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrSettlementDates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCashSettlementDate();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFuturesSettlementDate();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 cash_settlement_date = 1;
 * @return {number}
 */
proto.it_grpc.ITrdrSettlementDates.prototype.getCashSettlementDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrSettlementDates} returns this
 */
proto.it_grpc.ITrdrSettlementDates.prototype.setCashSettlementDate = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 futures_settlement_date = 2;
 * @return {number}
 */
proto.it_grpc.ITrdrSettlementDates.prototype.getFuturesSettlementDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrSettlementDates} returns this
 */
proto.it_grpc.ITrdrSettlementDates.prototype.setFuturesSettlementDate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrInstrumentDefinitions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentDefinitions.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentDefinitions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentDefinitions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentDefinitions.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrumentDefsList: jspb.Message.toObjectList(msg.getInstrumentDefsList(),
    proto.it_grpc.ITrdrInstrumentDefinitionMsg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitions}
 */
proto.it_grpc.ITrdrInstrumentDefinitions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentDefinitions;
  return proto.it_grpc.ITrdrInstrumentDefinitions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentDefinitions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitions}
 */
proto.it_grpc.ITrdrInstrumentDefinitions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrInstrumentDefinitionMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrInstrumentDefinitionMsg.deserializeBinaryFromReader);
      msg.addInstrumentDefs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentDefinitions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentDefinitions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentDefinitions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentDefinitions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstrumentDefsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrInstrumentDefinitionMsg.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrInstrumentDefinitionMsg instrument_defs = 1;
 * @return {!Array<!proto.it_grpc.ITrdrInstrumentDefinitionMsg>}
 */
proto.it_grpc.ITrdrInstrumentDefinitions.prototype.getInstrumentDefsList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrInstrumentDefinitionMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrInstrumentDefinitionMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrInstrumentDefinitionMsg>} value
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitions} returns this
*/
proto.it_grpc.ITrdrInstrumentDefinitions.prototype.setInstrumentDefsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrInstrumentDefinitionMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitionMsg}
 */
proto.it_grpc.ITrdrInstrumentDefinitions.prototype.addInstrumentDefs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrInstrumentDefinitionMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitions} returns this
 */
proto.it_grpc.ITrdrInstrumentDefinitions.prototype.clearInstrumentDefsList = function() {
  return this.setInstrumentDefsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentDefinitionMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentDefinitionMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    instrumentDef: (f = msg.getInstrumentDef()) && itrdrinstrumentstatus_pb.ITrdrSecurityDefinition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitionMsg}
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentDefinitionMsg;
  return proto.it_grpc.ITrdrInstrumentDefinitionMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentDefinitionMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitionMsg}
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new itrdrinstrumentstatus_pb.ITrdrSecurityDefinition;
      reader.readMessage(value,itrdrinstrumentstatus_pb.ITrdrSecurityDefinition.deserializeBinaryFromReader);
      msg.setInstrumentDef(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentDefinitionMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentDefinitionMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentDef();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      itrdrinstrumentstatus_pb.ITrdrSecurityDefinition.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitionMsg} returns this
*/
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitionMsg} returns this
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitionMsg} returns this
*/
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitionMsg} returns this
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ITrdrSecurityDefinition instrument_def = 3;
 * @return {?proto.it_grpc.ITrdrSecurityDefinition}
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.getInstrumentDef = function() {
  return /** @type{?proto.it_grpc.ITrdrSecurityDefinition} */ (
    jspb.Message.getWrapperField(this, itrdrinstrumentstatus_pb.ITrdrSecurityDefinition, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrSecurityDefinition|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitionMsg} returns this
*/
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.setInstrumentDef = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentDefinitionMsg} returns this
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.clearInstrumentDef = function() {
  return this.setInstrumentDef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentDefinitionMsg.prototype.hasInstrumentDef = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrInstruments.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstruments.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstruments.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstruments} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstruments.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrumentsList: jspb.Message.toObjectList(msg.getInstrumentsList(),
    proto.it_grpc.ITrdrInstrumentMsg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstruments}
 */
proto.it_grpc.ITrdrInstruments.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstruments;
  return proto.it_grpc.ITrdrInstruments.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstruments} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstruments}
 */
proto.it_grpc.ITrdrInstruments.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrInstrumentMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrInstrumentMsg.deserializeBinaryFromReader);
      msg.addInstruments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstruments.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstruments.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstruments} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstruments.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstrumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrInstrumentMsg.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrInstrumentMsg instruments = 1;
 * @return {!Array<!proto.it_grpc.ITrdrInstrumentMsg>}
 */
proto.it_grpc.ITrdrInstruments.prototype.getInstrumentsList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrInstrumentMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrInstrumentMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrInstrumentMsg>} value
 * @return {!proto.it_grpc.ITrdrInstruments} returns this
*/
proto.it_grpc.ITrdrInstruments.prototype.setInstrumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrInstrumentMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrInstrumentMsg}
 */
proto.it_grpc.ITrdrInstruments.prototype.addInstruments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrInstrumentMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrInstruments} returns this
 */
proto.it_grpc.ITrdrInstruments.prototype.clearInstrumentsList = function() {
  return this.setInstrumentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentSaveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentSaveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    actionType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    instrument: (f = msg.getInstrument()) && proto.it_grpc.ITrdrInstruments.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentSaveRequest}
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentSaveRequest;
  return proto.it_grpc.ITrdrInstrumentSaveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentSaveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentSaveRequest}
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.it_grpc.InstrumentSaveAction} */ (reader.readEnum());
      msg.setActionType(value);
      break;
    case 2:
      var value = new proto.it_grpc.ITrdrInstruments;
      reader.readMessage(value,proto.it_grpc.ITrdrInstruments.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentSaveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentSaveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActionType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.it_grpc.ITrdrInstruments.serializeBinaryToWriter
    );
  }
};


/**
 * optional InstrumentSaveAction action_type = 1;
 * @return {!proto.it_grpc.InstrumentSaveAction}
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.prototype.getActionType = function() {
  return /** @type {!proto.it_grpc.InstrumentSaveAction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.it_grpc.InstrumentSaveAction} value
 * @return {!proto.it_grpc.ITrdrInstrumentSaveRequest} returns this
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.prototype.setActionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ITrdrInstruments instrument = 2;
 * @return {?proto.it_grpc.ITrdrInstruments}
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.prototype.getInstrument = function() {
  return /** @type{?proto.it_grpc.ITrdrInstruments} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrInstruments, 2));
};


/**
 * @param {?proto.it_grpc.ITrdrInstruments|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentSaveRequest} returns this
*/
proto.it_grpc.ITrdrInstrumentSaveRequest.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentSaveRequest} returns this
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentSaveRequest.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    instrument: (f = msg.getInstrument()) && itrdrinstrument_pb.ITrdrInstrument.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentMsg}
 */
proto.it_grpc.ITrdrInstrumentMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentMsg;
  return proto.it_grpc.ITrdrInstrumentMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentMsg}
 */
proto.it_grpc.ITrdrInstrumentMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new itrdrinstrument_pb.ITrdrInstrument;
      reader.readMessage(value,itrdrinstrument_pb.ITrdrInstrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      itrdrinstrument_pb.ITrdrInstrument.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentMsg} returns this
*/
proto.it_grpc.ITrdrInstrumentMsg.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentMsg} returns this
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentMsg} returns this
*/
proto.it_grpc.ITrdrInstrumentMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentMsg} returns this
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ITrdrInstrument instrument = 3;
 * @return {?proto.it_grpc.ITrdrInstrument}
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.getInstrument = function() {
  return /** @type{?proto.it_grpc.ITrdrInstrument} */ (
    jspb.Message.getWrapperField(this, itrdrinstrument_pb.ITrdrInstrument, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrInstrument|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentMsg} returns this
*/
proto.it_grpc.ITrdrInstrumentMsg.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentMsg} returns this
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentMsg.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrOrderOwnershipTransferMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrOrderOwnershipTransferMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    password: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ordIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrOrderOwnershipTransferMsg}
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrOrderOwnershipTransferMsg;
  return proto.it_grpc.ITrdrOrderOwnershipTransferMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrOrderOwnershipTransferMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrOrderOwnershipTransferMsg}
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addOrdIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrOrderOwnershipTransferMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrOrderOwnershipTransferMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrdIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrderOwnershipTransferMsg} returns this
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrderOwnershipTransferMsg} returns this
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string ord_ids = 3;
 * @return {!Array<string>}
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.prototype.getOrdIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.it_grpc.ITrdrOrderOwnershipTransferMsg} returns this
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.prototype.setOrdIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrOrderOwnershipTransferMsg} returns this
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.prototype.addOrdIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrOrderOwnershipTransferMsg} returns this
 */
proto.it_grpc.ITrdrOrderOwnershipTransferMsg.prototype.clearOrdIdsList = function() {
  return this.setOrdIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrOrderIDs.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrOrderIDs.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrOrderIDs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrOrderIDs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrderIDs.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrOrderIDs}
 */
proto.it_grpc.ITrdrOrderIDs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrOrderIDs;
  return proto.it_grpc.ITrdrOrderIDs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrOrderIDs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrOrderIDs}
 */
proto.it_grpc.ITrdrOrderIDs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addOrderIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrOrderIDs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrOrderIDs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrOrderIDs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrderIDs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string order_ids = 1;
 * @return {!Array<string>}
 */
proto.it_grpc.ITrdrOrderIDs.prototype.getOrderIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.it_grpc.ITrdrOrderIDs} returns this
 */
proto.it_grpc.ITrdrOrderIDs.prototype.setOrderIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrOrderIDs} returns this
 */
proto.it_grpc.ITrdrOrderIDs.prototype.addOrderIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrOrderIDs} returns this
 */
proto.it_grpc.ITrdrOrderIDs.prototype.clearOrderIdsList = function() {
  return this.setOrderIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrOrderMsg.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrOrderMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrOrderMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrderMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && itrdrmsgs_common_pb.ITrdrMessageStatus.toObject(includeInstance, f),
    linksList: jspb.Message.toObjectList(msg.getLinksList(),
    itrdrmsgs_common_pb.LinkObjects.toObject, includeInstance),
    order: (f = msg.getOrder()) && itrdrorder_pb.ITrdrOrder.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrOrderMsg}
 */
proto.it_grpc.ITrdrOrderMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrOrderMsg;
  return proto.it_grpc.ITrdrOrderMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrOrderMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrOrderMsg}
 */
proto.it_grpc.ITrdrOrderMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new itrdrmsgs_common_pb.ITrdrMessageStatus;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrMessageStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 4:
      var value = new itrdrmsgs_common_pb.LinkObjects;
      reader.readMessage(value,itrdrmsgs_common_pb.LinkObjects.deserializeBinaryFromReader);
      msg.addLinks(value);
      break;
    case 5:
      var value = new itrdrorder_pb.ITrdrOrder;
      reader.readMessage(value,itrdrorder_pb.ITrdrOrder.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrOrderMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrOrderMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrderMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      itrdrmsgs_common_pb.ITrdrMessageStatus.serializeBinaryToWriter
    );
  }
  f = message.getLinksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      itrdrmsgs_common_pb.LinkObjects.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      itrdrorder_pb.ITrdrOrder.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrOrderMsg} returns this
*/
proto.it_grpc.ITrdrOrderMsg.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrderMsg} returns this
 */
proto.it_grpc.ITrdrOrderMsg.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrOrderMsg} returns this
*/
proto.it_grpc.ITrdrOrderMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrderMsg} returns this
 */
proto.it_grpc.ITrdrOrderMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ITrdrMessageStatus status = 3;
 * @return {?proto.it_grpc.ITrdrMessageStatus}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.getStatus = function() {
  return /** @type{?proto.it_grpc.ITrdrMessageStatus} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrMessageStatus, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrMessageStatus|undefined} value
 * @return {!proto.it_grpc.ITrdrOrderMsg} returns this
*/
proto.it_grpc.ITrdrOrderMsg.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrderMsg} returns this
 */
proto.it_grpc.ITrdrOrderMsg.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated LinkObjects links = 4;
 * @return {!Array<!proto.it_grpc.LinkObjects>}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.getLinksList = function() {
  return /** @type{!Array<!proto.it_grpc.LinkObjects>} */ (
    jspb.Message.getRepeatedWrapperField(this, itrdrmsgs_common_pb.LinkObjects, 4));
};


/**
 * @param {!Array<!proto.it_grpc.LinkObjects>} value
 * @return {!proto.it_grpc.ITrdrOrderMsg} returns this
*/
proto.it_grpc.ITrdrOrderMsg.prototype.setLinksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.it_grpc.LinkObjects=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.LinkObjects}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.addLinks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.it_grpc.LinkObjects, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrOrderMsg} returns this
 */
proto.it_grpc.ITrdrOrderMsg.prototype.clearLinksList = function() {
  return this.setLinksList([]);
};


/**
 * optional ITrdrOrder order = 5;
 * @return {?proto.it_grpc.ITrdrOrder}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.getOrder = function() {
  return /** @type{?proto.it_grpc.ITrdrOrder} */ (
    jspb.Message.getWrapperField(this, itrdrorder_pb.ITrdrOrder, 5));
};


/**
 * @param {?proto.it_grpc.ITrdrOrder|undefined} value
 * @return {!proto.it_grpc.ITrdrOrderMsg} returns this
*/
proto.it_grpc.ITrdrOrderMsg.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrderMsg} returns this
 */
proto.it_grpc.ITrdrOrderMsg.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrderMsg.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrOvernightOrders.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrOvernightOrders.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrOvernightOrders.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrOvernightOrders} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOvernightOrders.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordersList: jspb.Message.toObjectList(msg.getOrdersList(),
    proto.it_grpc.ITrdrOvernightOrderMsg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrOvernightOrders}
 */
proto.it_grpc.ITrdrOvernightOrders.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrOvernightOrders;
  return proto.it_grpc.ITrdrOvernightOrders.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrOvernightOrders} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrOvernightOrders}
 */
proto.it_grpc.ITrdrOvernightOrders.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrOvernightOrderMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrOvernightOrderMsg.deserializeBinaryFromReader);
      msg.addOrders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrOvernightOrders.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrOvernightOrders.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrOvernightOrders} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOvernightOrders.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrOvernightOrderMsg.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrOvernightOrderMsg orders = 1;
 * @return {!Array<!proto.it_grpc.ITrdrOvernightOrderMsg>}
 */
proto.it_grpc.ITrdrOvernightOrders.prototype.getOrdersList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrOvernightOrderMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrOvernightOrderMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrOvernightOrderMsg>} value
 * @return {!proto.it_grpc.ITrdrOvernightOrders} returns this
*/
proto.it_grpc.ITrdrOvernightOrders.prototype.setOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrOvernightOrderMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg}
 */
proto.it_grpc.ITrdrOvernightOrders.prototype.addOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrOvernightOrderMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrOvernightOrders} returns this
 */
proto.it_grpc.ITrdrOvernightOrders.prototype.clearOrdersList = function() {
  return this.setOrdersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrOvernightOrderMsg.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrOvernightOrderMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrOvernightOrderMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOvernightOrderMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && itrdrmsgs_common_pb.ITrdrMessageStatus.toObject(includeInstance, f),
    linksList: jspb.Message.toObjectList(msg.getLinksList(),
    itrdrmsgs_common_pb.LinkObjects.toObject, includeInstance),
    order: (f = msg.getOrder()) && itrdrorder_pb.ITrdrOvernightOrder.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrOvernightOrderMsg;
  return proto.it_grpc.ITrdrOvernightOrderMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrOvernightOrderMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new itrdrmsgs_common_pb.ITrdrMessageStatus;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrMessageStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 4:
      var value = new itrdrmsgs_common_pb.LinkObjects;
      reader.readMessage(value,itrdrmsgs_common_pb.LinkObjects.deserializeBinaryFromReader);
      msg.addLinks(value);
      break;
    case 5:
      var value = new itrdrorder_pb.ITrdrOvernightOrder;
      reader.readMessage(value,itrdrorder_pb.ITrdrOvernightOrder.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrOvernightOrderMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrOvernightOrderMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOvernightOrderMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      itrdrmsgs_common_pb.ITrdrMessageStatus.serializeBinaryToWriter
    );
  }
  f = message.getLinksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      itrdrmsgs_common_pb.LinkObjects.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      itrdrorder_pb.ITrdrOvernightOrder.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg} returns this
*/
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg} returns this
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg} returns this
*/
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg} returns this
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ITrdrMessageStatus status = 3;
 * @return {?proto.it_grpc.ITrdrMessageStatus}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.getStatus = function() {
  return /** @type{?proto.it_grpc.ITrdrMessageStatus} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrMessageStatus, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrMessageStatus|undefined} value
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg} returns this
*/
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg} returns this
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated LinkObjects links = 4;
 * @return {!Array<!proto.it_grpc.LinkObjects>}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.getLinksList = function() {
  return /** @type{!Array<!proto.it_grpc.LinkObjects>} */ (
    jspb.Message.getRepeatedWrapperField(this, itrdrmsgs_common_pb.LinkObjects, 4));
};


/**
 * @param {!Array<!proto.it_grpc.LinkObjects>} value
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg} returns this
*/
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.setLinksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.it_grpc.LinkObjects=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.LinkObjects}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.addLinks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.it_grpc.LinkObjects, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg} returns this
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.clearLinksList = function() {
  return this.setLinksList([]);
};


/**
 * optional ITrdrOvernightOrder order = 5;
 * @return {?proto.it_grpc.ITrdrOvernightOrder}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.getOrder = function() {
  return /** @type{?proto.it_grpc.ITrdrOvernightOrder} */ (
    jspb.Message.getWrapperField(this, itrdrorder_pb.ITrdrOvernightOrder, 5));
};


/**
 * @param {?proto.it_grpc.ITrdrOvernightOrder|undefined} value
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg} returns this
*/
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOvernightOrderMsg} returns this
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrderMsg.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrOrders.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrOrders.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrOrders.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrOrders} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrders.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordersList: jspb.Message.toObjectList(msg.getOrdersList(),
    proto.it_grpc.ITrdrOrderMsg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrOrders}
 */
proto.it_grpc.ITrdrOrders.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrOrders;
  return proto.it_grpc.ITrdrOrders.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrOrders} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrOrders}
 */
proto.it_grpc.ITrdrOrders.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrOrderMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrOrderMsg.deserializeBinaryFromReader);
      msg.addOrders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrOrders.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrOrders.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrOrders} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrders.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrOrderMsg.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrOrderMsg orders = 1;
 * @return {!Array<!proto.it_grpc.ITrdrOrderMsg>}
 */
proto.it_grpc.ITrdrOrders.prototype.getOrdersList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrOrderMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrOrderMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrOrderMsg>} value
 * @return {!proto.it_grpc.ITrdrOrders} returns this
*/
proto.it_grpc.ITrdrOrders.prototype.setOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrOrderMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrOrderMsg}
 */
proto.it_grpc.ITrdrOrders.prototype.addOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrOrderMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrOrders} returns this
 */
proto.it_grpc.ITrdrOrders.prototype.clearOrdersList = function() {
  return this.setOrdersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrExecutionReportMsg.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrExecutionReportMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrExecutionReportMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExecutionReportMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && itrdrmsgs_common_pb.ITrdrMessageStatus.toObject(includeInstance, f),
    linksList: jspb.Message.toObjectList(msg.getLinksList(),
    itrdrmsgs_common_pb.LinkObjects.toObject, includeInstance),
    execReport: (f = msg.getExecReport()) && singlegeneralorderhandling_pb.ExecutionReport.toObject(includeInstance, f),
    sendStp: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg}
 */
proto.it_grpc.ITrdrExecutionReportMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrExecutionReportMsg;
  return proto.it_grpc.ITrdrExecutionReportMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrExecutionReportMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg}
 */
proto.it_grpc.ITrdrExecutionReportMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new itrdrmsgs_common_pb.ITrdrMessageStatus;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrMessageStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 4:
      var value = new itrdrmsgs_common_pb.LinkObjects;
      reader.readMessage(value,itrdrmsgs_common_pb.LinkObjects.deserializeBinaryFromReader);
      msg.addLinks(value);
      break;
    case 5:
      var value = new singlegeneralorderhandling_pb.ExecutionReport;
      reader.readMessage(value,singlegeneralorderhandling_pb.ExecutionReport.deserializeBinaryFromReader);
      msg.setExecReport(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendStp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrExecutionReportMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrExecutionReportMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExecutionReportMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      itrdrmsgs_common_pb.ITrdrMessageStatus.serializeBinaryToWriter
    );
  }
  f = message.getLinksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      itrdrmsgs_common_pb.LinkObjects.serializeBinaryToWriter
    );
  }
  f = message.getExecReport();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      singlegeneralorderhandling_pb.ExecutionReport.serializeBinaryToWriter
    );
  }
  f = message.getSendStp();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
*/
proto.it_grpc.ITrdrExecutionReportMsg.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
*/
proto.it_grpc.ITrdrExecutionReportMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ITrdrMessageStatus status = 3;
 * @return {?proto.it_grpc.ITrdrMessageStatus}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.getStatus = function() {
  return /** @type{?proto.it_grpc.ITrdrMessageStatus} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrMessageStatus, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrMessageStatus|undefined} value
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
*/
proto.it_grpc.ITrdrExecutionReportMsg.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated LinkObjects links = 4;
 * @return {!Array<!proto.it_grpc.LinkObjects>}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.getLinksList = function() {
  return /** @type{!Array<!proto.it_grpc.LinkObjects>} */ (
    jspb.Message.getRepeatedWrapperField(this, itrdrmsgs_common_pb.LinkObjects, 4));
};


/**
 * @param {!Array<!proto.it_grpc.LinkObjects>} value
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
*/
proto.it_grpc.ITrdrExecutionReportMsg.prototype.setLinksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.it_grpc.LinkObjects=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.LinkObjects}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.addLinks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.it_grpc.LinkObjects, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.clearLinksList = function() {
  return this.setLinksList([]);
};


/**
 * optional SingleGeneralOrderHandling.ExecutionReport exec_report = 5;
 * @return {?proto.SingleGeneralOrderHandling.ExecutionReport}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.getExecReport = function() {
  return /** @type{?proto.SingleGeneralOrderHandling.ExecutionReport} */ (
    jspb.Message.getWrapperField(this, singlegeneralorderhandling_pb.ExecutionReport, 5));
};


/**
 * @param {?proto.SingleGeneralOrderHandling.ExecutionReport|undefined} value
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
*/
proto.it_grpc.ITrdrExecutionReportMsg.prototype.setExecReport = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.clearExecReport = function() {
  return this.setExecReport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.hasExecReport = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool send_stp = 6;
 * @return {boolean}
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.getSendStp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg} returns this
 */
proto.it_grpc.ITrdrExecutionReportMsg.prototype.setSendStp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrExecutionReport.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrExecutionReport.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrExecutionReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrExecutionReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExecutionReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    executionList: jspb.Message.toObjectList(msg.getExecutionList(),
    proto.it_grpc.ITrdrExecutionReportMsg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrExecutionReport}
 */
proto.it_grpc.ITrdrExecutionReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrExecutionReport;
  return proto.it_grpc.ITrdrExecutionReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrExecutionReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrExecutionReport}
 */
proto.it_grpc.ITrdrExecutionReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrExecutionReportMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrExecutionReportMsg.deserializeBinaryFromReader);
      msg.addExecution(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrExecutionReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrExecutionReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrExecutionReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExecutionReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExecutionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrExecutionReportMsg.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrExecutionReportMsg execution = 1;
 * @return {!Array<!proto.it_grpc.ITrdrExecutionReportMsg>}
 */
proto.it_grpc.ITrdrExecutionReport.prototype.getExecutionList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrExecutionReportMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrExecutionReportMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrExecutionReportMsg>} value
 * @return {!proto.it_grpc.ITrdrExecutionReport} returns this
*/
proto.it_grpc.ITrdrExecutionReport.prototype.setExecutionList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrExecutionReportMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrExecutionReportMsg}
 */
proto.it_grpc.ITrdrExecutionReport.prototype.addExecution = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrExecutionReportMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrExecutionReport} returns this
 */
proto.it_grpc.ITrdrExecutionReport.prototype.clearExecutionList = function() {
  return this.setExecutionList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrExecutionReportAckMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrExecutionReportAckMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    statusMessage: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrExecutionReportAckMsg}
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrExecutionReportAckMsg;
  return proto.it_grpc.ITrdrExecutionReportAckMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrExecutionReportAckMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrExecutionReportAckMsg}
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.it_grpc.MsgStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrExecutionReportAckMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrExecutionReportAckMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStatusMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional ObjectId id = 1;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 1));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrExecutionReportAckMsg} returns this
*/
proto.it_grpc.ITrdrExecutionReportAckMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrExecutionReportAckMsg} returns this
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MsgStatus status = 2;
 * @return {!proto.it_grpc.MsgStatus}
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.prototype.getStatus = function() {
  return /** @type {!proto.it_grpc.MsgStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.it_grpc.MsgStatus} value
 * @return {!proto.it_grpc.ITrdrExecutionReportAckMsg} returns this
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string status_message = 3;
 * @return {string}
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.prototype.getStatusMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrExecutionReportAckMsg} returns this
 */
proto.it_grpc.ITrdrExecutionReportAckMsg.prototype.setStatusMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrExecutionReportAck.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrExecutionReportAck.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrExecutionReportAck.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrExecutionReportAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExecutionReportAck.toObject = function(includeInstance, msg) {
  var f, obj = {
    ackList: jspb.Message.toObjectList(msg.getAckList(),
    proto.it_grpc.ITrdrExecutionReportAckMsg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrExecutionReportAck}
 */
proto.it_grpc.ITrdrExecutionReportAck.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrExecutionReportAck;
  return proto.it_grpc.ITrdrExecutionReportAck.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrExecutionReportAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrExecutionReportAck}
 */
proto.it_grpc.ITrdrExecutionReportAck.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrExecutionReportAckMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrExecutionReportAckMsg.deserializeBinaryFromReader);
      msg.addAck(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrExecutionReportAck.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrExecutionReportAck.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrExecutionReportAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExecutionReportAck.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAckList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrExecutionReportAckMsg.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrExecutionReportAckMsg ack = 1;
 * @return {!Array<!proto.it_grpc.ITrdrExecutionReportAckMsg>}
 */
proto.it_grpc.ITrdrExecutionReportAck.prototype.getAckList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrExecutionReportAckMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrExecutionReportAckMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrExecutionReportAckMsg>} value
 * @return {!proto.it_grpc.ITrdrExecutionReportAck} returns this
*/
proto.it_grpc.ITrdrExecutionReportAck.prototype.setAckList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrExecutionReportAckMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrExecutionReportAckMsg}
 */
proto.it_grpc.ITrdrExecutionReportAck.prototype.addAck = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrExecutionReportAckMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrExecutionReportAck} returns this
 */
proto.it_grpc.ITrdrExecutionReportAck.prototype.clearAckList = function() {
  return this.setAckList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.it_grpc.ITrdrUserAuthentication.oneofGroups_ = [[5,6]];

/**
 * @enum {number}
 */
proto.it_grpc.ITrdrUserAuthentication.LogonResponseCase = {
  LOGON_RESPONSE_NOT_SET: 0,
  LOG_ON: 5,
  LOG_OUT: 6
};

/**
 * @return {proto.it_grpc.ITrdrUserAuthentication.LogonResponseCase}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.getLogonResponseCase = function() {
  return /** @type {proto.it_grpc.ITrdrUserAuthentication.LogonResponseCase} */(jspb.Message.computeOneofCase(this, proto.it_grpc.ITrdrUserAuthentication.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrUserAuthentication.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrUserAuthentication} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUserAuthentication.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && itrdrmsgs_common_pb.ITrdrMessageStatus.toObject(includeInstance, f),
    links: (f = msg.getLinks()) && itrdrmsgs_common_pb.LinkObjects.toObject(includeInstance, f),
    logOn: (f = msg.getLogOn()) && session_pb.Logon.toObject(includeInstance, f),
    logOut: (f = msg.getLogOut()) && session_pb.Logout.toObject(includeInstance, f),
    userCredentials: (f = msg.getUserCredentials()) && proto.it_grpc.ITrdrUserCredentials.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrUserAuthentication}
 */
proto.it_grpc.ITrdrUserAuthentication.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrUserAuthentication;
  return proto.it_grpc.ITrdrUserAuthentication.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrUserAuthentication} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrUserAuthentication}
 */
proto.it_grpc.ITrdrUserAuthentication.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new itrdrmsgs_common_pb.ITrdrMessageStatus;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrMessageStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 4:
      var value = new itrdrmsgs_common_pb.LinkObjects;
      reader.readMessage(value,itrdrmsgs_common_pb.LinkObjects.deserializeBinaryFromReader);
      msg.setLinks(value);
      break;
    case 5:
      var value = new session_pb.Logon;
      reader.readMessage(value,session_pb.Logon.deserializeBinaryFromReader);
      msg.setLogOn(value);
      break;
    case 6:
      var value = new session_pb.Logout;
      reader.readMessage(value,session_pb.Logout.deserializeBinaryFromReader);
      msg.setLogOut(value);
      break;
    case 7:
      var value = new proto.it_grpc.ITrdrUserCredentials;
      reader.readMessage(value,proto.it_grpc.ITrdrUserCredentials.deserializeBinaryFromReader);
      msg.setUserCredentials(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrUserAuthentication.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrUserAuthentication} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUserAuthentication.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      itrdrmsgs_common_pb.ITrdrMessageStatus.serializeBinaryToWriter
    );
  }
  f = message.getLinks();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      itrdrmsgs_common_pb.LinkObjects.serializeBinaryToWriter
    );
  }
  f = message.getLogOn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      session_pb.Logon.serializeBinaryToWriter
    );
  }
  f = message.getLogOut();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      session_pb.Logout.serializeBinaryToWriter
    );
  }
  f = message.getUserCredentials();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.it_grpc.ITrdrUserCredentials.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
*/
proto.it_grpc.ITrdrUserAuthentication.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
*/
proto.it_grpc.ITrdrUserAuthentication.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ITrdrMessageStatus status = 3;
 * @return {?proto.it_grpc.ITrdrMessageStatus}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.getStatus = function() {
  return /** @type{?proto.it_grpc.ITrdrMessageStatus} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrMessageStatus, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrMessageStatus|undefined} value
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
*/
proto.it_grpc.ITrdrUserAuthentication.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional LinkObjects links = 4;
 * @return {?proto.it_grpc.LinkObjects}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.getLinks = function() {
  return /** @type{?proto.it_grpc.LinkObjects} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.LinkObjects, 4));
};


/**
 * @param {?proto.it_grpc.LinkObjects|undefined} value
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
*/
proto.it_grpc.ITrdrUserAuthentication.prototype.setLinks = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.clearLinks = function() {
  return this.setLinks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.hasLinks = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Session.Logon log_on = 5;
 * @return {?proto.Session.Logon}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.getLogOn = function() {
  return /** @type{?proto.Session.Logon} */ (
    jspb.Message.getWrapperField(this, session_pb.Logon, 5));
};


/**
 * @param {?proto.Session.Logon|undefined} value
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
*/
proto.it_grpc.ITrdrUserAuthentication.prototype.setLogOn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.it_grpc.ITrdrUserAuthentication.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.clearLogOn = function() {
  return this.setLogOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.hasLogOn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Session.Logout log_out = 6;
 * @return {?proto.Session.Logout}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.getLogOut = function() {
  return /** @type{?proto.Session.Logout} */ (
    jspb.Message.getWrapperField(this, session_pb.Logout, 6));
};


/**
 * @param {?proto.Session.Logout|undefined} value
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
*/
proto.it_grpc.ITrdrUserAuthentication.prototype.setLogOut = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.it_grpc.ITrdrUserAuthentication.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.clearLogOut = function() {
  return this.setLogOut(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.hasLogOut = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ITrdrUserCredentials user_credentials = 7;
 * @return {?proto.it_grpc.ITrdrUserCredentials}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.getUserCredentials = function() {
  return /** @type{?proto.it_grpc.ITrdrUserCredentials} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrUserCredentials, 7));
};


/**
 * @param {?proto.it_grpc.ITrdrUserCredentials|undefined} value
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
*/
proto.it_grpc.ITrdrUserAuthentication.prototype.setUserCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserAuthentication} returns this
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.clearUserCredentials = function() {
  return this.setUserCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserAuthentication.prototype.hasUserCredentials = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrUserCredentials.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrUserCredentials.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrUserCredentials} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUserCredentials.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    userCredentials: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrUserCredentials}
 */
proto.it_grpc.ITrdrUserCredentials.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrUserCredentials;
  return proto.it_grpc.ITrdrUserCredentials.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrUserCredentials} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrUserCredentials}
 */
proto.it_grpc.ITrdrUserCredentials.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserCredentials(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrUserCredentials.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrUserCredentials.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrUserCredentials} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUserCredentials.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getUserCredentials();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrUserCredentials.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrUserCredentials} returns this
*/
proto.it_grpc.ITrdrUserCredentials.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserCredentials} returns this
 */
proto.it_grpc.ITrdrUserCredentials.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserCredentials.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrUserCredentials.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrUserCredentials} returns this
*/
proto.it_grpc.ITrdrUserCredentials.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserCredentials} returns this
 */
proto.it_grpc.ITrdrUserCredentials.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserCredentials.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string user_credentials = 3;
 * @return {string}
 */
proto.it_grpc.ITrdrUserCredentials.prototype.getUserCredentials = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrUserCredentials} returns this
 */
proto.it_grpc.ITrdrUserCredentials.prototype.setUserCredentials = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrAllocationProfile.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrAllocationProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrAllocationProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrAllocationProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrAllocationProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
    allocProfileList: jspb.Message.toObjectList(msg.getAllocProfileList(),
    proto.it_grpc.ITrdrAllocationProfileMsg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrAllocationProfile}
 */
proto.it_grpc.ITrdrAllocationProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrAllocationProfile;
  return proto.it_grpc.ITrdrAllocationProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrAllocationProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrAllocationProfile}
 */
proto.it_grpc.ITrdrAllocationProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrAllocationProfileMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrAllocationProfileMsg.deserializeBinaryFromReader);
      msg.addAllocProfile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrAllocationProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrAllocationProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrAllocationProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrAllocationProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllocProfileList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrAllocationProfileMsg.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrAllocationProfileMsg alloc_profile = 1;
 * @return {!Array<!proto.it_grpc.ITrdrAllocationProfileMsg>}
 */
proto.it_grpc.ITrdrAllocationProfile.prototype.getAllocProfileList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrAllocationProfileMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrAllocationProfileMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrAllocationProfileMsg>} value
 * @return {!proto.it_grpc.ITrdrAllocationProfile} returns this
*/
proto.it_grpc.ITrdrAllocationProfile.prototype.setAllocProfileList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrAllocationProfileMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg}
 */
proto.it_grpc.ITrdrAllocationProfile.prototype.addAllocProfile = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrAllocationProfileMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrAllocationProfile} returns this
 */
proto.it_grpc.ITrdrAllocationProfile.prototype.clearAllocProfileList = function() {
  return this.setAllocProfileList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrAllocationProfileMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrAllocationProfileMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrAllocationProfileMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && itrdrmsgs_common_pb.ITrdrMessageStatus.toObject(includeInstance, f),
    allocationProfile: (f = msg.getAllocationProfile()) && proto.it_grpc.AllocationProfile.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrAllocationProfileMsg;
  return proto.it_grpc.ITrdrAllocationProfileMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrAllocationProfileMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new itrdrmsgs_common_pb.ITrdrMessageStatus;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrMessageStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 4:
      var value = new proto.it_grpc.AllocationProfile;
      reader.readMessage(value,proto.it_grpc.AllocationProfile.deserializeBinaryFromReader);
      msg.setAllocationProfile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrAllocationProfileMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrAllocationProfileMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrAllocationProfileMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      itrdrmsgs_common_pb.ITrdrMessageStatus.serializeBinaryToWriter
    );
  }
  f = message.getAllocationProfile();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.it_grpc.AllocationProfile.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg} returns this
*/
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg} returns this
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg} returns this
*/
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg} returns this
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ITrdrMessageStatus status = 3;
 * @return {?proto.it_grpc.ITrdrMessageStatus}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.getStatus = function() {
  return /** @type{?proto.it_grpc.ITrdrMessageStatus} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrMessageStatus, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrMessageStatus|undefined} value
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg} returns this
*/
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg} returns this
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional AllocationProfile allocation_profile = 4;
 * @return {?proto.it_grpc.AllocationProfile}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.getAllocationProfile = function() {
  return /** @type{?proto.it_grpc.AllocationProfile} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.AllocationProfile, 4));
};


/**
 * @param {?proto.it_grpc.AllocationProfile|undefined} value
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg} returns this
*/
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.setAllocationProfile = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrAllocationProfileMsg} returns this
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.clearAllocationProfile = function() {
  return this.setAllocationProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrAllocationProfileMsg.prototype.hasAllocationProfile = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrExchange.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrExchange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrExchange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExchange.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    exchangeCode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    shortName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrExchange}
 */
proto.it_grpc.ITrdrExchange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrExchange;
  return proto.it_grpc.ITrdrExchange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrExchange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrExchange}
 */
proto.it_grpc.ITrdrExchange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExchangeCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrExchange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrExchange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrExchange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrExchange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExchangeCode();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getShortName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrExchange.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrExchange} returns this
 */
proto.it_grpc.ITrdrExchange.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 exchange_code = 2;
 * @return {number}
 */
proto.it_grpc.ITrdrExchange.prototype.getExchangeCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrExchange} returns this
 */
proto.it_grpc.ITrdrExchange.prototype.setExchangeCode = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string short_name = 3;
 * @return {string}
 */
proto.it_grpc.ITrdrExchange.prototype.getShortName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrExchange} returns this
 */
proto.it_grpc.ITrdrExchange.prototype.setShortName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.NVPair.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.NVPair.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.NVPair} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.NVPair.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.NVPair}
 */
proto.it_grpc.NVPair.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.NVPair;
  return proto.it_grpc.NVPair.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.NVPair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.NVPair}
 */
proto.it_grpc.NVPair.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.NVPair.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.NVPair.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.NVPair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.NVPair.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.it_grpc.NVPair.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.NVPair} returns this
 */
proto.it_grpc.NVPair.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.it_grpc.NVPair.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.NVPair} returns this
 */
proto.it_grpc.NVPair.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.AllocationProfile.repeatedFields_ = [3,20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.AllocationProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.AllocationProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.AllocationProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.AllocationProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
    profileName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    numSplits: jspb.Message.getFieldWithDefault(msg, 2, 0),
    splitDefaultsList: jspb.Message.toObjectList(msg.getSplitDefaultsList(),
    proto.it_grpc.AllocationProfile.SplitDefaults.toObject, includeInstance),
    subaccount: jspb.Message.getFieldWithDefault(msg, 4, ""),
    specialInstructions1: jspb.Message.getFieldWithDefault(msg, 5, ""),
    giveupAcct: jspb.Message.getFieldWithDefault(msg, 6, ""),
    emailTo: jspb.Message.getFieldWithDefault(msg, 7, ""),
    emailCc: jspb.Message.getFieldWithDefault(msg, 8, ""),
    traderName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    senderId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    receiverId: jspb.Message.getFieldWithDefault(msg, 11, ""),
    portfolio: jspb.Message.getFieldWithDefault(msg, 12, ""),
    broker: jspb.Message.getFieldWithDefault(msg, 13, ""),
    emailBcc: jspb.Message.getFieldWithDefault(msg, 14, ""),
    bookingCpty: jspb.Message.getFieldWithDefault(msg, 15, ""),
    bookingTrader: jspb.Message.getFieldWithDefault(msg, 16, ""),
    reportType: jspb.Message.getFieldWithDefault(msg, 17, 0),
    vconAttachment: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    clAttachment: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    allocProfileAttribsList: jspb.Message.toObjectList(msg.getAllocProfileAttribsList(),
    proto.it_grpc.NVPair.toObject, includeInstance),
    vconAvgPr: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    vconIndPr: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
    clAvgPr: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
    clIndPr: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    clFutOnly: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    bnp: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
    tenaron: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
    capula: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
    vconCashOnly: jspb.Message.getBooleanFieldWithDefault(msg, 29, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.AllocationProfile}
 */
proto.it_grpc.AllocationProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.AllocationProfile;
  return proto.it_grpc.AllocationProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.AllocationProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.AllocationProfile}
 */
proto.it_grpc.AllocationProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumSplits(value);
      break;
    case 3:
      var value = new proto.it_grpc.AllocationProfile.SplitDefaults;
      reader.readMessage(value,proto.it_grpc.AllocationProfile.SplitDefaults.deserializeBinaryFromReader);
      msg.addSplitDefaults(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubaccount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpecialInstructions1(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setGiveupAcct(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailTo(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailCc(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTraderName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiverId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPortfolio(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailBcc(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBookingCpty(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setBookingTrader(value);
      break;
    case 17:
      var value = /** @type {!proto.it_grpc.AllocationProfile.report_typ_enum} */ (reader.readEnum());
      msg.setReportType(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVconAttachment(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClAttachment(value);
      break;
    case 20:
      var value = new proto.it_grpc.NVPair;
      reader.readMessage(value,proto.it_grpc.NVPair.deserializeBinaryFromReader);
      msg.addAllocProfileAttribs(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVconAvgPr(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVconIndPr(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClAvgPr(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClIndPr(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClFutOnly(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBnp(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTenaron(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCapula(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVconCashOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.AllocationProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.AllocationProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.AllocationProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.AllocationProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfileName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNumSplits();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSplitDefaultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.it_grpc.AllocationProfile.SplitDefaults.serializeBinaryToWriter
    );
  }
  f = message.getSubaccount();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSpecialInstructions1();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getGiveupAcct();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEmailTo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEmailCc();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTraderName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSenderId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getReceiverId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPortfolio();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getEmailBcc();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getBookingCpty();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getBookingTrader();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getReportType();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getVconAttachment();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getClAttachment();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getAllocProfileAttribsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      20,
      f,
      proto.it_grpc.NVPair.serializeBinaryToWriter
    );
  }
  f = message.getVconAvgPr();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getVconIndPr();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getClAvgPr();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getClIndPr();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getClFutOnly();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getBnp();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = message.getTenaron();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getCapula();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getVconCashOnly();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.it_grpc.AllocationProfile.report_typ_enum = {
  INDFILLS: 0,
  AVGPR: 1
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.AllocationProfile.SplitDefaults.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.AllocationProfile.SplitDefaults.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.AllocationProfile.SplitDefaults} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.AllocationProfile.SplitDefaults.toObject = function(includeInstance, msg) {
  var f, obj = {
    splitIndex: jspb.Message.getFieldWithDefault(msg, 1, 0),
    defultSplitPercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    defaultBook: jspb.Message.getFieldWithDefault(msg, 3, ""),
    splitInfoList: jspb.Message.toObjectList(msg.getSplitInfoList(),
    proto.it_grpc.NVPair.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.AllocationProfile.SplitDefaults}
 */
proto.it_grpc.AllocationProfile.SplitDefaults.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.AllocationProfile.SplitDefaults;
  return proto.it_grpc.AllocationProfile.SplitDefaults.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.AllocationProfile.SplitDefaults} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.AllocationProfile.SplitDefaults}
 */
proto.it_grpc.AllocationProfile.SplitDefaults.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSplitIndex(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDefultSplitPercent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultBook(value);
      break;
    case 4:
      var value = new proto.it_grpc.NVPair;
      reader.readMessage(value,proto.it_grpc.NVPair.deserializeBinaryFromReader);
      msg.addSplitInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.AllocationProfile.SplitDefaults.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.AllocationProfile.SplitDefaults} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.AllocationProfile.SplitDefaults.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSplitIndex();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDefultSplitPercent();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getDefaultBook();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSplitInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.it_grpc.NVPair.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 split_index = 1;
 * @return {number}
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.getSplitIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.AllocationProfile.SplitDefaults} returns this
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.setSplitIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double defult_split_percent = 2;
 * @return {number}
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.getDefultSplitPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.AllocationProfile.SplitDefaults} returns this
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.setDefultSplitPercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string default_book = 3;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.getDefaultBook = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile.SplitDefaults} returns this
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.setDefaultBook = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated NVPair split_info = 4;
 * @return {!Array<!proto.it_grpc.NVPair>}
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.getSplitInfoList = function() {
  return /** @type{!Array<!proto.it_grpc.NVPair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.NVPair, 4));
};


/**
 * @param {!Array<!proto.it_grpc.NVPair>} value
 * @return {!proto.it_grpc.AllocationProfile.SplitDefaults} returns this
*/
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.setSplitInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.it_grpc.NVPair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.NVPair}
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.addSplitInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.it_grpc.NVPair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.AllocationProfile.SplitDefaults} returns this
 */
proto.it_grpc.AllocationProfile.SplitDefaults.prototype.clearSplitInfoList = function() {
  return this.setSplitInfoList([]);
};


/**
 * optional string profile_name = 1;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getProfileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setProfileName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 num_splits = 2;
 * @return {number}
 */
proto.it_grpc.AllocationProfile.prototype.getNumSplits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setNumSplits = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated SplitDefaults split_defaults = 3;
 * @return {!Array<!proto.it_grpc.AllocationProfile.SplitDefaults>}
 */
proto.it_grpc.AllocationProfile.prototype.getSplitDefaultsList = function() {
  return /** @type{!Array<!proto.it_grpc.AllocationProfile.SplitDefaults>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.AllocationProfile.SplitDefaults, 3));
};


/**
 * @param {!Array<!proto.it_grpc.AllocationProfile.SplitDefaults>} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
*/
proto.it_grpc.AllocationProfile.prototype.setSplitDefaultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.it_grpc.AllocationProfile.SplitDefaults=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.AllocationProfile.SplitDefaults}
 */
proto.it_grpc.AllocationProfile.prototype.addSplitDefaults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.it_grpc.AllocationProfile.SplitDefaults, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.clearSplitDefaultsList = function() {
  return this.setSplitDefaultsList([]);
};


/**
 * optional string subaccount = 4;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getSubaccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setSubaccount = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string special_instructions1 = 5;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getSpecialInstructions1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setSpecialInstructions1 = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string giveup_acct = 6;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getGiveupAcct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setGiveupAcct = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string email_to = 7;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getEmailTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setEmailTo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string email_cc = 8;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getEmailCc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setEmailCc = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string trader_name = 9;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getTraderName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setTraderName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string sender_id = 10;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getSenderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setSenderId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string receiver_id = 11;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getReceiverId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setReceiverId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string portfolio = 12;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getPortfolio = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setPortfolio = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string broker = 13;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string email_bcc = 14;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getEmailBcc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setEmailBcc = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string booking_cpty = 15;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getBookingCpty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setBookingCpty = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string booking_trader = 16;
 * @return {string}
 */
proto.it_grpc.AllocationProfile.prototype.getBookingTrader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setBookingTrader = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional report_typ_enum report_type = 17;
 * @return {!proto.it_grpc.AllocationProfile.report_typ_enum}
 */
proto.it_grpc.AllocationProfile.prototype.getReportType = function() {
  return /** @type {!proto.it_grpc.AllocationProfile.report_typ_enum} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.it_grpc.AllocationProfile.report_typ_enum} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setReportType = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional bool vcon_attachment = 18;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getVconAttachment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setVconAttachment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional bool cl_attachment = 19;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getClAttachment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setClAttachment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * repeated NVPair alloc_profile_attribs = 20;
 * @return {!Array<!proto.it_grpc.NVPair>}
 */
proto.it_grpc.AllocationProfile.prototype.getAllocProfileAttribsList = function() {
  return /** @type{!Array<!proto.it_grpc.NVPair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.NVPair, 20));
};


/**
 * @param {!Array<!proto.it_grpc.NVPair>} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
*/
proto.it_grpc.AllocationProfile.prototype.setAllocProfileAttribsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 20, value);
};


/**
 * @param {!proto.it_grpc.NVPair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.NVPair}
 */
proto.it_grpc.AllocationProfile.prototype.addAllocProfileAttribs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.it_grpc.NVPair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.clearAllocProfileAttribsList = function() {
  return this.setAllocProfileAttribsList([]);
};


/**
 * optional bool vcon_avg_pr = 21;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getVconAvgPr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setVconAvgPr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional bool vcon_ind_pr = 22;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getVconIndPr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setVconIndPr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool cl_avg_pr = 23;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getClAvgPr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setClAvgPr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool cl_ind_pr = 24;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getClIndPr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setClIndPr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional bool cl_fut_only = 25;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getClFutOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setClFutOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional bool bnp = 26;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getBnp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setBnp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * optional bool tenaron = 27;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getTenaron = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setTenaron = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional bool capula = 28;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getCapula = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setCapula = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * optional bool vcon_cash_only = 29;
 * @return {boolean}
 */
proto.it_grpc.AllocationProfile.prototype.getVconCashOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.AllocationProfile} returns this
 */
proto.it_grpc.AllocationProfile.prototype.setVconCashOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrSalesTicket.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrSalesTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrSalesTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrSalesTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrSalesTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
    salesTicketList: jspb.Message.toObjectList(msg.getSalesTicketList(),
    proto.it_grpc.ITrdrSalesTicketMsg.toObject, includeInstance),
    parentOrderIdList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrSalesTicket}
 */
proto.it_grpc.ITrdrSalesTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrSalesTicket;
  return proto.it_grpc.ITrdrSalesTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrSalesTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrSalesTicket}
 */
proto.it_grpc.ITrdrSalesTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrSalesTicketMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrSalesTicketMsg.deserializeBinaryFromReader);
      msg.addSalesTicket(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addParentOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrSalesTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrSalesTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrSalesTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrSalesTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesTicketList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrSalesTicketMsg.serializeBinaryToWriter
    );
  }
  f = message.getParentOrderIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated ITrdrSalesTicketMsg sales_ticket = 1;
 * @return {!Array<!proto.it_grpc.ITrdrSalesTicketMsg>}
 */
proto.it_grpc.ITrdrSalesTicket.prototype.getSalesTicketList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrSalesTicketMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrSalesTicketMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrSalesTicketMsg>} value
 * @return {!proto.it_grpc.ITrdrSalesTicket} returns this
*/
proto.it_grpc.ITrdrSalesTicket.prototype.setSalesTicketList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrSalesTicketMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg}
 */
proto.it_grpc.ITrdrSalesTicket.prototype.addSalesTicket = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrSalesTicketMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrSalesTicket} returns this
 */
proto.it_grpc.ITrdrSalesTicket.prototype.clearSalesTicketList = function() {
  return this.setSalesTicketList([]);
};


/**
 * repeated string parent_order_id = 2;
 * @return {!Array<string>}
 */
proto.it_grpc.ITrdrSalesTicket.prototype.getParentOrderIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.it_grpc.ITrdrSalesTicket} returns this
 */
proto.it_grpc.ITrdrSalesTicket.prototype.setParentOrderIdList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrSalesTicket} returns this
 */
proto.it_grpc.ITrdrSalesTicket.prototype.addParentOrderId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrSalesTicket} returns this
 */
proto.it_grpc.ITrdrSalesTicket.prototype.clearParentOrderIdList = function() {
  return this.setParentOrderIdList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrSalesTicketMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrSalesTicketMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrSalesTicketMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && itrdrmsgs_common_pb.ITrdrMessageStatus.toObject(includeInstance, f),
    salesTickt: (f = msg.getSalesTickt()) && proto.it_grpc.SalesTicket.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg}
 */
proto.it_grpc.ITrdrSalesTicketMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrSalesTicketMsg;
  return proto.it_grpc.ITrdrSalesTicketMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrSalesTicketMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg}
 */
proto.it_grpc.ITrdrSalesTicketMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new itrdrmsgs_common_pb.ITrdrMessageStatus;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrMessageStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 4:
      var value = new proto.it_grpc.SalesTicket;
      reader.readMessage(value,proto.it_grpc.SalesTicket.deserializeBinaryFromReader);
      msg.setSalesTickt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrSalesTicketMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrSalesTicketMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrSalesTicketMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      itrdrmsgs_common_pb.ITrdrMessageStatus.serializeBinaryToWriter
    );
  }
  f = message.getSalesTickt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.it_grpc.SalesTicket.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg} returns this
*/
proto.it_grpc.ITrdrSalesTicketMsg.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg} returns this
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg} returns this
*/
proto.it_grpc.ITrdrSalesTicketMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg} returns this
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ITrdrMessageStatus status = 3;
 * @return {?proto.it_grpc.ITrdrMessageStatus}
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.getStatus = function() {
  return /** @type{?proto.it_grpc.ITrdrMessageStatus} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrMessageStatus, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrMessageStatus|undefined} value
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg} returns this
*/
proto.it_grpc.ITrdrSalesTicketMsg.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg} returns this
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SalesTicket sales_tickt = 4;
 * @return {?proto.it_grpc.SalesTicket}
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.getSalesTickt = function() {
  return /** @type{?proto.it_grpc.SalesTicket} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.SalesTicket, 4));
};


/**
 * @param {?proto.it_grpc.SalesTicket|undefined} value
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg} returns this
*/
proto.it_grpc.ITrdrSalesTicketMsg.prototype.setSalesTickt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrSalesTicketMsg} returns this
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.clearSalesTickt = function() {
  return this.setSalesTickt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrSalesTicketMsg.prototype.hasSalesTickt = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.SalesTicket.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.SalesTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.SalesTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.SalesTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.SalesTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
    subaccount: jspb.Message.getFieldWithDefault(msg, 1, ""),
    salesTicketDataList: jspb.Message.toObjectList(msg.getSalesTicketDataList(),
    proto.it_grpc.NVPair.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.SalesTicket}
 */
proto.it_grpc.SalesTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.SalesTicket;
  return proto.it_grpc.SalesTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.SalesTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.SalesTicket}
 */
proto.it_grpc.SalesTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubaccount(value);
      break;
    case 2:
      var value = new proto.it_grpc.NVPair;
      reader.readMessage(value,proto.it_grpc.NVPair.deserializeBinaryFromReader);
      msg.addSalesTicketData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.SalesTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.SalesTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.SalesTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.SalesTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubaccount();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSalesTicketDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.it_grpc.NVPair.serializeBinaryToWriter
    );
  }
};


/**
 * optional string subaccount = 1;
 * @return {string}
 */
proto.it_grpc.SalesTicket.prototype.getSubaccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.SalesTicket} returns this
 */
proto.it_grpc.SalesTicket.prototype.setSubaccount = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated NVPair sales_ticket_data = 2;
 * @return {!Array<!proto.it_grpc.NVPair>}
 */
proto.it_grpc.SalesTicket.prototype.getSalesTicketDataList = function() {
  return /** @type{!Array<!proto.it_grpc.NVPair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.NVPair, 2));
};


/**
 * @param {!Array<!proto.it_grpc.NVPair>} value
 * @return {!proto.it_grpc.SalesTicket} returns this
*/
proto.it_grpc.SalesTicket.prototype.setSalesTicketDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.it_grpc.NVPair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.NVPair}
 */
proto.it_grpc.SalesTicket.prototype.addSalesTicketData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.it_grpc.NVPair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.SalesTicket} returns this
 */
proto.it_grpc.SalesTicket.prototype.clearSalesTicketDataList = function() {
  return this.setSalesTicketDataList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrInstrumentTemplate.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentTemplate.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentTemplate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentTemplate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentTemplate.toObject = function(includeInstance, msg) {
  var f, obj = {
    instTemplatesList: jspb.Message.toObjectList(msg.getInstTemplatesList(),
    proto.it_grpc.ITrdrInstrumentTemplateMsg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentTemplate}
 */
proto.it_grpc.ITrdrInstrumentTemplate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentTemplate;
  return proto.it_grpc.ITrdrInstrumentTemplate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentTemplate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentTemplate}
 */
proto.it_grpc.ITrdrInstrumentTemplate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrInstrumentTemplateMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrInstrumentTemplateMsg.deserializeBinaryFromReader);
      msg.addInstTemplates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentTemplate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentTemplate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentTemplate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentTemplate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstTemplatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrInstrumentTemplateMsg.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrInstrumentTemplateMsg inst_templates = 1;
 * @return {!Array<!proto.it_grpc.ITrdrInstrumentTemplateMsg>}
 */
proto.it_grpc.ITrdrInstrumentTemplate.prototype.getInstTemplatesList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrInstrumentTemplateMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrInstrumentTemplateMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrInstrumentTemplateMsg>} value
 * @return {!proto.it_grpc.ITrdrInstrumentTemplate} returns this
*/
proto.it_grpc.ITrdrInstrumentTemplate.prototype.setInstTemplatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrInstrumentTemplateMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg}
 */
proto.it_grpc.ITrdrInstrumentTemplate.prototype.addInstTemplates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrInstrumentTemplateMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrInstrumentTemplate} returns this
 */
proto.it_grpc.ITrdrInstrumentTemplate.prototype.clearInstTemplatesList = function() {
  return this.setInstTemplatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentTemplateMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentTemplateMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && itrdrmsgs_common_pb.ITrdrMessageStatus.toObject(includeInstance, f),
    instrumentTemplate: (f = msg.getInstrumentTemplate()) && proto.it_grpc.InstrumentTemplate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentTemplateMsg;
  return proto.it_grpc.ITrdrInstrumentTemplateMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentTemplateMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new itrdrmsgs_common_pb.ITrdrMessageStatus;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrMessageStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 4:
      var value = new proto.it_grpc.InstrumentTemplate;
      reader.readMessage(value,proto.it_grpc.InstrumentTemplate.deserializeBinaryFromReader);
      msg.setInstrumentTemplate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentTemplateMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentTemplateMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      itrdrmsgs_common_pb.ITrdrMessageStatus.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentTemplate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.it_grpc.InstrumentTemplate.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg} returns this
*/
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg} returns this
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg} returns this
*/
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg} returns this
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ITrdrMessageStatus status = 3;
 * @return {?proto.it_grpc.ITrdrMessageStatus}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.getStatus = function() {
  return /** @type{?proto.it_grpc.ITrdrMessageStatus} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrMessageStatus, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrMessageStatus|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg} returns this
*/
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg} returns this
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional InstrumentTemplate instrument_template = 4;
 * @return {?proto.it_grpc.InstrumentTemplate}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.getInstrumentTemplate = function() {
  return /** @type{?proto.it_grpc.InstrumentTemplate} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.InstrumentTemplate, 4));
};


/**
 * @param {?proto.it_grpc.InstrumentTemplate|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg} returns this
*/
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.setInstrumentTemplate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentTemplateMsg} returns this
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.clearInstrumentTemplate = function() {
  return this.setInstrumentTemplate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentTemplateMsg.prototype.hasInstrumentTemplate = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.InstrumentTemplate.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.InstrumentTemplate.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.InstrumentTemplate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.InstrumentTemplate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.InstrumentTemplate.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    templateCategory: jspb.Message.getFieldWithDefault(msg, 2, 0),
    templateInfoList: jspb.Message.toObjectList(msg.getTemplateInfoList(),
    proto.it_grpc.NVPair.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.InstrumentTemplate}
 */
proto.it_grpc.InstrumentTemplate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.InstrumentTemplate;
  return proto.it_grpc.InstrumentTemplate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.InstrumentTemplate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.InstrumentTemplate}
 */
proto.it_grpc.InstrumentTemplate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.it_grpc.TemplateCategoryEnum} */ (reader.readEnum());
      msg.setTemplateCategory(value);
      break;
    case 3:
      var value = new proto.it_grpc.NVPair;
      reader.readMessage(value,proto.it_grpc.NVPair.deserializeBinaryFromReader);
      msg.addTemplateInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.InstrumentTemplate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.InstrumentTemplate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.InstrumentTemplate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.InstrumentTemplate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTemplateCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTemplateInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.it_grpc.NVPair.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.it_grpc.InstrumentTemplate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.InstrumentTemplate} returns this
 */
proto.it_grpc.InstrumentTemplate.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TemplateCategoryEnum template_category = 2;
 * @return {!proto.it_grpc.TemplateCategoryEnum}
 */
proto.it_grpc.InstrumentTemplate.prototype.getTemplateCategory = function() {
  return /** @type {!proto.it_grpc.TemplateCategoryEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.it_grpc.TemplateCategoryEnum} value
 * @return {!proto.it_grpc.InstrumentTemplate} returns this
 */
proto.it_grpc.InstrumentTemplate.prototype.setTemplateCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated NVPair template_info = 3;
 * @return {!Array<!proto.it_grpc.NVPair>}
 */
proto.it_grpc.InstrumentTemplate.prototype.getTemplateInfoList = function() {
  return /** @type{!Array<!proto.it_grpc.NVPair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.NVPair, 3));
};


/**
 * @param {!Array<!proto.it_grpc.NVPair>} value
 * @return {!proto.it_grpc.InstrumentTemplate} returns this
*/
proto.it_grpc.InstrumentTemplate.prototype.setTemplateInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.it_grpc.NVPair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.NVPair}
 */
proto.it_grpc.InstrumentTemplate.prototype.addTemplateInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.it_grpc.NVPair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.InstrumentTemplate} returns this
 */
proto.it_grpc.InstrumentTemplate.prototype.clearTemplateInfoList = function() {
  return this.setTemplateInfoList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrHolidayCalendar.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrHolidayCalendar.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrHolidayCalendar.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrHolidayCalendar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrHolidayCalendar.toObject = function(includeInstance, msg) {
  var f, obj = {
    holidayCalendarList: jspb.Message.toObjectList(msg.getHolidayCalendarList(),
    proto.it_grpc.ITrdrHolidayCalendarMsg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrHolidayCalendar}
 */
proto.it_grpc.ITrdrHolidayCalendar.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrHolidayCalendar;
  return proto.it_grpc.ITrdrHolidayCalendar.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrHolidayCalendar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrHolidayCalendar}
 */
proto.it_grpc.ITrdrHolidayCalendar.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrHolidayCalendarMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrHolidayCalendarMsg.deserializeBinaryFromReader);
      msg.addHolidayCalendar(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrHolidayCalendar.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrHolidayCalendar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrHolidayCalendar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrHolidayCalendar.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHolidayCalendarList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrHolidayCalendarMsg.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrHolidayCalendarMsg holiday_calendar = 1;
 * @return {!Array<!proto.it_grpc.ITrdrHolidayCalendarMsg>}
 */
proto.it_grpc.ITrdrHolidayCalendar.prototype.getHolidayCalendarList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrHolidayCalendarMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrHolidayCalendarMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrHolidayCalendarMsg>} value
 * @return {!proto.it_grpc.ITrdrHolidayCalendar} returns this
*/
proto.it_grpc.ITrdrHolidayCalendar.prototype.setHolidayCalendarList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrHolidayCalendarMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg}
 */
proto.it_grpc.ITrdrHolidayCalendar.prototype.addHolidayCalendar = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrHolidayCalendarMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrHolidayCalendar} returns this
 */
proto.it_grpc.ITrdrHolidayCalendar.prototype.clearHolidayCalendarList = function() {
  return this.setHolidayCalendarList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrHolidayCalendarMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrHolidayCalendarMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && itrdrmsgs_common_pb.ITrdrMessageStatus.toObject(includeInstance, f),
    holidayCal: (f = msg.getHolidayCal()) && proto.it_grpc.HolidayCalendar.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrHolidayCalendarMsg;
  return proto.it_grpc.ITrdrHolidayCalendarMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrHolidayCalendarMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new itrdrmsgs_common_pb.ITrdrMessageStatus;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrMessageStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 4:
      var value = new proto.it_grpc.HolidayCalendar;
      reader.readMessage(value,proto.it_grpc.HolidayCalendar.deserializeBinaryFromReader);
      msg.setHolidayCal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrHolidayCalendarMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrHolidayCalendarMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      itrdrmsgs_common_pb.ITrdrMessageStatus.serializeBinaryToWriter
    );
  }
  f = message.getHolidayCal();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.it_grpc.HolidayCalendar.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg} returns this
*/
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg} returns this
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg} returns this
*/
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg} returns this
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ITrdrMessageStatus status = 3;
 * @return {?proto.it_grpc.ITrdrMessageStatus}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.getStatus = function() {
  return /** @type{?proto.it_grpc.ITrdrMessageStatus} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrMessageStatus, 3));
};


/**
 * @param {?proto.it_grpc.ITrdrMessageStatus|undefined} value
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg} returns this
*/
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg} returns this
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional HolidayCalendar holiday_cal = 4;
 * @return {?proto.it_grpc.HolidayCalendar}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.getHolidayCal = function() {
  return /** @type{?proto.it_grpc.HolidayCalendar} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.HolidayCalendar, 4));
};


/**
 * @param {?proto.it_grpc.HolidayCalendar|undefined} value
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg} returns this
*/
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.setHolidayCal = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrHolidayCalendarMsg} returns this
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.clearHolidayCal = function() {
  return this.setHolidayCal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrHolidayCalendarMsg.prototype.hasHolidayCal = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.HolidayCalendar.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.HolidayCalendar.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.HolidayCalendar.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.HolidayCalendar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.HolidayCalendar.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateHoltypeList: jspb.Message.toObjectList(msg.getDateHoltypeList(),
    proto.it_grpc.NVPair.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.HolidayCalendar}
 */
proto.it_grpc.HolidayCalendar.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.HolidayCalendar;
  return proto.it_grpc.HolidayCalendar.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.HolidayCalendar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.HolidayCalendar}
 */
proto.it_grpc.HolidayCalendar.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.NVPair;
      reader.readMessage(value,proto.it_grpc.NVPair.deserializeBinaryFromReader);
      msg.addDateHoltype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.HolidayCalendar.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.HolidayCalendar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.HolidayCalendar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.HolidayCalendar.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateHoltypeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.NVPair.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NVPair date_holtype = 1;
 * @return {!Array<!proto.it_grpc.NVPair>}
 */
proto.it_grpc.HolidayCalendar.prototype.getDateHoltypeList = function() {
  return /** @type{!Array<!proto.it_grpc.NVPair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.NVPair, 1));
};


/**
 * @param {!Array<!proto.it_grpc.NVPair>} value
 * @return {!proto.it_grpc.HolidayCalendar} returns this
*/
proto.it_grpc.HolidayCalendar.prototype.setDateHoltypeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.NVPair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.NVPair}
 */
proto.it_grpc.HolidayCalendar.prototype.addDateHoltype = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.NVPair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.HolidayCalendar} returns this
 */
proto.it_grpc.HolidayCalendar.prototype.clearDateHoltypeList = function() {
  return this.setDateHoltypeList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrUserConfiguration.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrUserConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrUserConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrUserConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUserConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    usrConfList: jspb.Message.toObjectList(msg.getUsrConfList(),
    proto.it_grpc.ITrdrUserConfigurationMsg.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrUserConfiguration}
 */
proto.it_grpc.ITrdrUserConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrUserConfiguration;
  return proto.it_grpc.ITrdrUserConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrUserConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrUserConfiguration}
 */
proto.it_grpc.ITrdrUserConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrUserConfigurationMsg;
      reader.readMessage(value,proto.it_grpc.ITrdrUserConfigurationMsg.deserializeBinaryFromReader);
      msg.addUsrConf(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrUserConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrUserConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrUserConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUserConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsrConfList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.it_grpc.ITrdrUserConfigurationMsg.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ITrdrUserConfigurationMsg usr_conf = 1;
 * @return {!Array<!proto.it_grpc.ITrdrUserConfigurationMsg>}
 */
proto.it_grpc.ITrdrUserConfiguration.prototype.getUsrConfList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrUserConfigurationMsg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrUserConfigurationMsg, 1));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrUserConfigurationMsg>} value
 * @return {!proto.it_grpc.ITrdrUserConfiguration} returns this
*/
proto.it_grpc.ITrdrUserConfiguration.prototype.setUsrConfList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.it_grpc.ITrdrUserConfigurationMsg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrUserConfigurationMsg}
 */
proto.it_grpc.ITrdrUserConfiguration.prototype.addUsrConf = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.it_grpc.ITrdrUserConfigurationMsg, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrUserConfiguration} returns this
 */
proto.it_grpc.ITrdrUserConfiguration.prototype.clearUsrConfList = function() {
  return this.setUsrConfList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrUserConfigurationMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrUserConfigurationMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUserConfigurationMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && itrdrmsgs_common_pb.ITrdrCollectionMembership.toObject(includeInstance, f),
    id: (f = msg.getId()) && itrdrmsgs_common_pb.ObjectId.toObject(includeInstance, f),
    userConfig: (f = msg.getUserConfig()) && proto.it_grpc.UserConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrUserConfigurationMsg}
 */
proto.it_grpc.ITrdrUserConfigurationMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrUserConfigurationMsg;
  return proto.it_grpc.ITrdrUserConfigurationMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrUserConfigurationMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrUserConfigurationMsg}
 */
proto.it_grpc.ITrdrUserConfigurationMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrCollectionMembership;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = new itrdrmsgs_common_pb.ObjectId;
      reader.readMessage(value,itrdrmsgs_common_pb.ObjectId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 3:
      var value = new proto.it_grpc.UserConfiguration;
      reader.readMessage(value,proto.it_grpc.UserConfiguration.deserializeBinaryFromReader);
      msg.setUserConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrUserConfigurationMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrUserConfigurationMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUserConfigurationMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      itrdrmsgs_common_pb.ObjectId.serializeBinaryToWriter
    );
  }
  f = message.getUserConfig();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.it_grpc.UserConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.ITrdrUserConfigurationMsg} returns this
*/
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserConfigurationMsg} returns this
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObjectId id = 2;
 * @return {?proto.it_grpc.ObjectId}
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.getId = function() {
  return /** @type{?proto.it_grpc.ObjectId} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ObjectId, 2));
};


/**
 * @param {?proto.it_grpc.ObjectId|undefined} value
 * @return {!proto.it_grpc.ITrdrUserConfigurationMsg} returns this
*/
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserConfigurationMsg} returns this
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.hasId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UserConfiguration user_config = 3;
 * @return {?proto.it_grpc.UserConfiguration}
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.getUserConfig = function() {
  return /** @type{?proto.it_grpc.UserConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.UserConfiguration, 3));
};


/**
 * @param {?proto.it_grpc.UserConfiguration|undefined} value
 * @return {!proto.it_grpc.ITrdrUserConfigurationMsg} returns this
*/
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.setUserConfig = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUserConfigurationMsg} returns this
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.clearUserConfig = function() {
  return this.setUserConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUserConfigurationMsg.prototype.hasUserConfig = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.UserConfiguration.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.UserConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.UserConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.UserConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.UserConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    settingsInfoList: jspb.Message.toObjectList(msg.getSettingsInfoList(),
    proto.it_grpc.NVPair.toObject, includeInstance),
    themeColorList: jspb.Message.toObjectList(msg.getThemeColorList(),
    proto.it_grpc.NVPair.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.UserConfiguration}
 */
proto.it_grpc.UserConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.UserConfiguration;
  return proto.it_grpc.UserConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.UserConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.UserConfiguration}
 */
proto.it_grpc.UserConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.it_grpc.NVPair;
      reader.readMessage(value,proto.it_grpc.NVPair.deserializeBinaryFromReader);
      msg.addSettingsInfo(value);
      break;
    case 3:
      var value = new proto.it_grpc.NVPair;
      reader.readMessage(value,proto.it_grpc.NVPair.deserializeBinaryFromReader);
      msg.addThemeColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.UserConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.UserConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.UserConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.UserConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSettingsInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.it_grpc.NVPair.serializeBinaryToWriter
    );
  }
  f = message.getThemeColorList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.it_grpc.NVPair.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.it_grpc.UserConfiguration.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.UserConfiguration} returns this
 */
proto.it_grpc.UserConfiguration.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated NVPair settings_info = 2;
 * @return {!Array<!proto.it_grpc.NVPair>}
 */
proto.it_grpc.UserConfiguration.prototype.getSettingsInfoList = function() {
  return /** @type{!Array<!proto.it_grpc.NVPair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.NVPair, 2));
};


/**
 * @param {!Array<!proto.it_grpc.NVPair>} value
 * @return {!proto.it_grpc.UserConfiguration} returns this
*/
proto.it_grpc.UserConfiguration.prototype.setSettingsInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.it_grpc.NVPair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.NVPair}
 */
proto.it_grpc.UserConfiguration.prototype.addSettingsInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.it_grpc.NVPair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.UserConfiguration} returns this
 */
proto.it_grpc.UserConfiguration.prototype.clearSettingsInfoList = function() {
  return this.setSettingsInfoList([]);
};


/**
 * repeated NVPair theme_color = 3;
 * @return {!Array<!proto.it_grpc.NVPair>}
 */
proto.it_grpc.UserConfiguration.prototype.getThemeColorList = function() {
  return /** @type{!Array<!proto.it_grpc.NVPair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.NVPair, 3));
};


/**
 * @param {!Array<!proto.it_grpc.NVPair>} value
 * @return {!proto.it_grpc.UserConfiguration} returns this
*/
proto.it_grpc.UserConfiguration.prototype.setThemeColorList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.it_grpc.NVPair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.NVPair}
 */
proto.it_grpc.UserConfiguration.prototype.addThemeColor = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.it_grpc.NVPair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.UserConfiguration} returns this
 */
proto.it_grpc.UserConfiguration.prototype.clearThemeColorList = function() {
  return this.setThemeColorList([]);
};


goog.object.extend(exports, proto.it_grpc);
